<template>
  <main class="target-wallet">
    <header :class="{ error: !campaign.wallet_target }">select target</header>

    <div class="row" @click="updatedTarget('interests')">
      <sb-checkbox :checked="campaign.wallet_target==='interests'" data-cy="target-wallet-interests-input" /> interests
    </div>

    <div class="row" @click="updatedTarget('birthday')">
      <sb-checkbox :checked="campaign.wallet_target==='birthday'" data-cy="target-wallet-birthday-input" /> birthday
    </div>

    <div class="row" @click="updatedTarget('profile')">
      <sb-checkbox :checked="campaign.wallet_target==='profile'" data-cy="target-wallet-profile-input" /> profile
    </div>

    <div class="row" @click="updatedTarget('home')">
      <sb-checkbox :checked="campaign.wallet_target==='home'" data-cy="target-wallet-home-input" /> home
    </div>
  </main>
</template>

<script>
export default {
  name: "target-wallet",
  props: {
    selected: String
  },
  methods: {
    async updatedTarget(value) {
      await this.$store.dispatch('UPDATE_CAMPAIGN', { _type_options: value })
    }
  },
  computed: {
    campaign() { return this.$store.state.campaign }
  }
}
</script>

<style scoped>
.target-wallet {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  min-height: 215px;
}

header {
  margin-bottom: 4px;
  font-family: AileronThin;
}

header.error {
  color: #f91253;
}

.row {
  display: flex;
  align-items: center;
  min-width: 80px;
  font-size: 14px;
  color: #4a4a4a;
  line-height: 1.8;
  padding-left: 4px;
  cursor:pointer;
}

.row .sb-checkbox {
  margin-right: 5px;
  width: 13px;
  height: 13px;
  border: 1px solid #128ff9;
}
</style>
